import { render, staticRenderFns } from "./Disease.vue?vue&type=template&id=55229ced&scoped=true&"
import script from "./Disease.vue?vue&type=script&lang=ts&"
export * from "./Disease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55229ced",
  null
  
)

export default component.exports